import Swiper from 'swiper/bundle';

window.addEventListener('load', function () {
  if (this.document.querySelector('.featured-news__carousel')) {
    new Swiper('.featured-news__carousel', {
      slidesPerView: 1.2,
      spaceBetween: 20,
      watchOverflow: true,
      pagination: {
        el: '.featured-news__carousel .swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2.2,
        },
        1080: {
          slidesPerView: 4,
          spaceBetween: 34,
        },
      },
    });
  }
});
